module.exports = __webpack_public_path__ + "static/gull-89196d3192bf740b90c7dc44d133dfe9.jpg";